import { DateFormats, DateUtil } from "utilities/date-utilities";
import useAppContext from "utilities/hooks/useAppContext";
import * as lodash from 'lodash';

type EventDateViewProps = {
    date: Date | string,
    color?: boolean
}

const EventDateView = (props: EventDateViewProps) => {
    const context = useAppContext();
    const isToday = DateUtil.compareOnAsIsoDate(props.date as any, new Date());
    let className = 'text-left p-1 text-lg font-bold app-label sticky top-4';
    let date: any = lodash.clone(props.date);
    date = DateUtil.format(date, DateFormats.LONG_WEEK_SHORT_DATE);

    if(isToday) {
        date = <b>{context.t('calendar.today')} - {date}</b>;
        if(props.color) {
            className += " text-blue-900";
        }
    }

    return <span className={className}>{date}</span>;
}

export default EventDateView;
